import React from "react";
import { FormattedMessage } from "react-intl";
import PropTypes from "prop-types";
import { didUserHaveAssociatedClientError } from "../common/clientHelper";
import { toast } from "react-toastify";
import { connect } from "react-redux";
import * as loginActions from "../login/loginActions";
import { bindActionCreators } from "redux";

class NoDataPage extends React.Component {
    constructor(props) {
        super(props);
        this.handleReload =this.handleReload.bind(this);
    }

    componentWillMount() {
        if (didUserHaveAssociatedClientError()) {
            toast(<FormattedMessage id="clients.unauthorizedRedirectedExternalUser" />, {
                type: toast.TYPE.ERROR,
                autoClose: false,
            });
        }
    }
    handleReload(e){
        e.preventDefault();
        this.props.loginActions.verifyAuth().then(()=>{
            window.location.href="/dashboard";
        });
    }

    render() {
        return (
            <div className="no-data-page">
                <div className="content-container">
                    <h1 className="title">
                        <FormattedMessage id="error.noData.title" />
                    </h1>

                    <p className="description">
                        <FormattedMessage id="error.noData.description" />
                    </p>
                        <a
                            href=""
                            className="go-home-link"                           
                            onClick={this.handleReload}
                        >
                        <FormattedMessage id="error.noData.link" />
                    </a>
                </div>
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        loginActions: bindActionCreators(loginActions, dispatch),
    };
}
NoDataPage.propTypes = {
    loginActions: PropTypes.object,
};
export default connect(null, mapDispatchToProps)(NoDataPage);



// WEBPACK FOOTER //
// ./src/components/app/NoDataPage.js